import { msalInstance } from '../../utils/auth/Auth-utils';
import { loginRequestScope } from '../constantes';

export default class AuthService {
    constructor() {}

    async renewToken() {

        const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
        const request = {
            scopes: loginRequestScope,
            account: account
        };
        return msalInstance.acquireTokenSilent(request)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error("ERROR RENOVAR TOKEN: ", error)
            })
    }

}